@if (menus().length) {
<div class="flex flex-row wrapper">

    @for (menu of menus(); track menu.items) {
    @if (menu.items?.length) {

    <ul>
        <li class="title font-bold font-large">{{ menu.name }}</li>

        @for (item of menu.items; track item.id) {
        <li class="cursor-pointer font-light font-medium" [ngClass]="{ 'selected': isSelected(menu.id, item.id), 'disabled': item.disabled }"
            [attr.aria-disabled]="item.disabled || null"
            [attr.data-testid]="'player_settings_' + menu.id + '-' + item.id" (click)="select(menu, item)">

            @if (isSelected(menu.id, item.id)) {
            <div class="icon me-3">
                <img [src]="skinning.getImage('icon_check_mark')" />
            </div>
            }

            <div>{{ item.displayText }}</div>

        </li>
        }

    </ul>

    }
    }
</div>
}